<div #editor class="ql-editor" [ngClass]="{'readonly': readonly}" [attr.contenteditable]="!readonly" spellcheck="false"
    (input)="onContentChanged($event)" (keydown)="keyPress($event)" (blur)="blur($event)" (paste)="onPaste($event)">
</div>

@if (filteredMetadataSuggestions.length) {
<ul id="suggestionList" [attr.data-automation-id]="automationId + '-dropdown-menu'" class="autocomplete-list"
    [style.top.px]="posSuggestionList.top" [style.left.px]="posSuggestionList.left">
    @for (item of filteredMetadataSuggestions; track trackByFn($index)) {
    <li [attr.data-automation-id]="automationId + '-option-' + $index" [class.active-metadata]="$index === activeIndex"
        (mouseover)="activateIndexOnMouseOver($event, $index)" (mousedown)="selectMetadata(item.name)"
        [title]="item.description">
        <span [innerHTML]="setHighlightOnWord(item.name)"></span>
    </li>
    }
</ul>
}